import React from "react";
import ThankYou from "../components/ThankYou";
import Footer from "../components/Footer";
import apiUrl from "../components/Url";
import { Slide } from 'react-slideshow-image';
import { useState } from "react";
import SEO from "../components/SEO";
import { useLanguage } from '../i18n/translations';

export default function PersonalneIlustracije({ persolaneIlustracijeSlike, categories }) {
  const { translate } = useLanguage();

  const [showModal, setShowModal] = React.useState(false);
  const [modalText, setModalText] = React.useState({
    title: "",
    description: ""
  })



  const closeModal = () => {
    setShowModal(false);
  };


  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
    images: [], // Array to hold selected images
  });

  const [previewImages, setPreviewImages] = useState([]);

  const [formErrors, setFormErrors] = React.useState({});


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

  };

  React.useEffect(() => {
    if (formData.images && formData.images.length > 0) {
      setFormErrors((prevErrors) => {
        const { images, ...restErrors } = prevErrors; // Remove the 'images' error
        return restErrors;
      });
    }
  }, [formData.images]);


  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => URL.createObjectURL(file)); // Create URLs for previews
    setFormData({ ...formData, images: [...formData.images, ...files] });
    setPreviewImages([...previewImages, ...newImages]);
  };

  const removeImage = (index) => {
    // Remove the selected image from formData.images
    const newImages = [...formData.images];
    const newPreviews = [...previewImages];

    // Remove the image at the specified index
    newImages.splice(index, 1);
    newPreviews.splice(index, 1);

    // Update state with the new arrays
    setFormData({ ...formData, images: newImages });
    setPreviewImages(newPreviews);
  };


  const validateForm = () => {
    const errors = {};

    // Check if all fields are filled

    if (!formData.email) {
      errors.email = translate("Email is required");
    }

    if (formData.images.length === 0) {
      errors.images = translate("Please add at least one image");
    }





    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      errors.email = translate("Invalid email format");
    }

    console.log(errors)
    console.log(formData)




    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        // Create FormData object
        const formDataToSend = new FormData();

        // Append non-file fields
        formDataToSend.append('firstName', formData.firstName);
        formDataToSend.append('lastName', formData.lastName);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('message', formData.message);

        // Append images
        formData.images.forEach((image) => {
          formDataToSend.append('images[]', image); // Use 'images[]' for Laravel compatibility
        });

        // Send the FormData object
        const response = await fetch(`${apiUrl}/api/naruci/personalna-ilustracija`, {
          method: 'POST',
          body: formDataToSend, // No need to set Content-Type; it is set automatically
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log('API response:', data);

        // Handle the API response as needed
        if (data.message === '201') {
          setModalText({
            title: translate("Thank you!"),
            description: translate("Your submission has been received. We will be in touch and contact you soon!")
          })
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            message: "",
            images: [],
          })
          setPreviewImages([])
          setShowModal(true);
        } else {
          setModalText({
            title: translate("Error!"),
            description: translate("We couldn't complete your request. Please contact us via email at contact@bulkaceramics.com")
          })
          setShowModal(true);
          // Handle other success or error cases
        }
      } catch (error) {
        console.error(error.message);
        setModalText({
          title: translate("Error!"),
          description: translate("We couldn't complete your request. Please contact us via email at contact@bulkaceramics.com")
        })
        setShowModal(true);
        // Handle errors, such as network issues or server errors
      }
    } else {
      console.log("Form validation failed");
    }
  };

  return (
    <div>

      <SEO
        title="Personalizovane Ilustracije - Bulka Ceramics"
        description="Pretvorite svoju omiljenu fotografiju u jedinstvenu ilustraciju izrađenu prema vašim željama."
        type="product" 
        name="Bulka Ceramics" 
      />
      <div>
        <div className='h-[170px] w-full 768:h-[100px] '></div>
        <div className="w-full items-center justify-center flex flex-col">
          <h1 className="font-semibold font-sans text-3xl tracking-wide">{translate("Personalized Illustrations")}</h1>

          <div className="w-full mx-[10%]  py-4 flex flex-col sm:flex-row items-center justify-around bg-bgSkin mt-6">
            <div className="flex flex-col items-center justify-center">
              <span className=" font-bold tracking-wider text-center ">Instagram</span>
              <a href="https://www.instagram.com/eminkreativnistudio/" className="italic text-[#4D2D18]  text-xl">@Eminkreativnistudio</a>
            </div>
            <div className="flex flex-col items-center justify-center mt-6 sm:mt-0">
              <span className=" font-bold tracking-wider text-center ">Email</span>
              <a href="mailto:contact@bulkaceramics.com" className="italic text-[#4D2D18]  text-xl">contact@bulkaceramics.com</a>
            </div>
          </div>

          <div className="w-full  mt-24  items-center justify-center flex ">

            <div className="w-[100%]  flex items-center 2xl:items-start justify-center 2xl:space-x-6 px-2 2xl:px-0 2xl:flex-row flex-col">
              <div className="2xl:w-1/2  bg-white rounded p-6">

                <div class="w-full mx-auto   rounded-lg">
                  <h2 class="text-2xl font-semibold text-gray-800 mb-4">{translate("Custom illustrations")}</h2>
                  <p class="text-gray-700 mb-4">
                    {translate("Turn your favorite photo into a unique illustration made to your wishes. Illustrations are printed as high-quality giclée prints in formats from A5 to A2.")}
                  </p>
                  <div class="border-t border-gray-300 pt-4">
                    <h3 class="text-lg font-medium text-gray-800 mb-2">{translate("Price list:")}</h3>
                    <ul class="space-y-2">
                      <li class="text-gray-700">
                        <span class="font-semibold">{translate("For one person:")}</span>
                        <ul class="ml-4 space-y-1 text-gray-600">
                          <li>{translate("Up to A4:")} <span class="font-medium">60 €</span></li>
                          <li>A3: <span class="font-medium">70 €</span></li>
                          <li>A2: <span class="font-medium">90 €</span></li>
                        </ul>
                      </li>
                      <li class="text-gray-700">
                        <span class="font-semibold">{translate("For two or three people:")}</span>
                        <ul class="ml-4 space-y-1 text-gray-600">
                          <li>{translate("Up to A3:")} <span class="font-medium">100 €</span></li>
                          <li>A2: <span class="font-medium">120 €</span></li>
                        </ul>
                      </li>
                      <li class="text-gray-700">
                        <span class="font-semibold">{translate("Additional people:")}</span> 15 € {translate("per person")}
                      </li>
                      <li class="text-gray-700">
                        <span class="font-semibold">{translate("Pets:")}</span> {translate("Included at no extra charge")}
                      </li>
                    </ul>
                  </div>
                  <p class="text-gray-700 mt-4">
                    {translate("Treat yourself or a loved one to a memory that will brighten up any space!")}
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="font-sans w-full items-center justify-center mt-6">
                  <div className="flex flex-col sm:flex-row sm:space-x-12">
                    <div className="flex flex-col mt-4 w-full">
                      <label className="text-sm text-gray-900">{translate("First Name")}</label>
                      <input
                        className="border-b-2 border-b-gray-700 bg-transparent py-2 w-full focus:outline-none"
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                      {formErrors.firstName && <p className="text-red-500">{formErrors.firstName}</p>}
                    </div>
                    <div className="flex flex-col mt-4 w-full">
                      <label className="text-sm text-gray-900">{translate("Last Name")}</label>
                      <input
                        className="border-b-2 border-b-gray-700 bg-transparent py-2 w-full focus:outline-none"
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                      {formErrors.lastName && <p className="text-red-500">{formErrors.lastName}</p>}
                    </div>
                  </div>

                  <div className="flex flex-row space-x-12">
                    <div className="flex flex-col mt-4 w-full">
                      <label className="text-sm text-gray-900">{translate("Email*")}</label>
                      <input
                        className="border-b-2 border-b-gray-700 bg-transparent py-2 w-full focus:outline-none"
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {formErrors.email && <p className="text-red-500">{formErrors.email}</p>}
                    </div>
                  </div>

                  <div className="flex flex-row space-x-12">
                    <div className="flex flex-col mt-4 w-full">
                      <label className="text-sm text-gray-900">{translate("Description")}</label>
                      <input
                        className="border-b-2 border-b-gray-700 bg-transparent py-2 w-full focus:outline-none"
                        type="text"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                      {formErrors.message && <p className="text-red-500">{formErrors.message}</p>}
                    </div>
                  </div>

                  <div class="mt-8 bg-white rounded-lg  w-full">
                    <h2 class="text-xl font-semibold text-gray-800 mb-4">{translate("How to send photos for illustration?")}</h2>
                    <ul class="list-disc list-inside text-gray-700 space-y-3">
                      <li>
                        <strong>{translate("Attach clear photos")}</strong> {translate("that you want used to create the illustration.")}
                        <ul class="ml-6 list-disc list-inside space-y-1">
                          <li>{translate("We recommend high-quality photos, with good lighting and visible facial and clothing details.")}</li>
                          <li>{translate("You can attach multiple photos if you want to combine different details in one illustration.")}</li>
                        </ul>
                      </li>
                      <li>
                        {translate("If you have special requests (backgrounds, colors, clothing style or additional elements), write them in the description.")}
                      </li>
                      <li>
                        {translate("Allowed photo formats:")} <span class="font-medium">JPG, PNG</span>
                      </li>
                      <li>
                        {translate("Click on")} <span class="font-medium">"{translate("Add images")}"</span> {translate("to attach your photos, then fill in the other details and submit your request.")}
                      </li>
                    </ul>
                  </div>


                  {/* New Image Upload Input */}
                  <div className="flex flex-col mt-4 w-24">

                    <label htmlFor="input-file" className="bg-brownSkin text-white w-26 text-center py-2" >{translate("Add images")}</label>
                    <input
                      type="file"
                      id="input-file"
                      name="images[]"
                      multiple
                      accept="image/*"

                      onChange={handleFileChange}
                      className="hidden"

                    />

                  </div>

                  {/* Image Previews */}
                  <div className="flex flex-wrap mt-4 space-x-4">
                    {previewImages.map((image, index) => (
                      <div key={index} className="relative w-24 h-24">
                        <img src={image} alt={`Preview ${index}`} className="w-full h-full object-cover rounded-md" />
                        <button
                          type="button"
                          onClick={() => removeImage(index)}
                          className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 text-xs"
                        >
                          X
                        </button>
                      </div>
                    ))}
                    {formErrors.images && <p className="text-red-500">{formErrors.images}</p>}
                  </div>


                  <div className="w-full flex sm:justify-start justify-center">
                    <button type="submit" className="bg-darkerSkin w-[250px] mt-6 text-center py-3 text-black border-black border">
                      {translate("Order")}
                    </button>
                  </div>
                </form>

              </div>

              <div className="max-w-[500px] mt-6 2xl:mt-0  w-full h-[500px]  2xl:h-[800px] 2xl:max-w-[700px]  items-center">
                <Slide  duration={2000}  className="h-[500px]  2xl:h-[800px] 2xl:w-[700px] ">
                  {persolaneIlustracijeSlike.map((file, index) => (
                    <div className="each-slide-effect h-[500px]  2xl:h-[800px] 2xl:w-[700px]" key={index}>
                      <div
                        style={{
                          backgroundImage: `url(/images/ilustracije/personalne/${file})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          height: '100%',
                          width: '100%',
                        }}
                      />
                    </div>
                  ))}
                </Slide>
              </div>
            </div>




          </div>
        </div>
      </div>


      <div>
        {showModal && <ThankYou onClose={closeModal} modalText={modalText} />}
      </div>
      <Footer categories={categories} />

    </div>


  )
}